import { render, staticRenderFns } from "./avisos_detalle.vue?vue&type=template&id=629c529d&"
import script from "./avisos_detalle.vue?vue&type=script&lang=js&"
export * from "./avisos_detalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports